import { PhilosophyContext } from "../context/PhilosophyContext";
import { useContext } from "react";

export const usePhilosophyContext = () => {
    const context = useContext(PhilosophyContext);

    if (!context) {
        return Error('usePhilosophyContext must be used inside an PhilosophyContextProvider');
    };

    return context;
};